import axios from 'axios'

export default axios.create({
  //baseURL: 'https://aeromall.com.sv/aeromall-admin2/public/api',
  baseURL: 'http://34.106.141.22/aeromall-adminfix/public/api',
  //baseURL: 'http://backendleweb.com/public/api'
  //baseURL: 'http://34.106.141.22/aeromall-admin/public/api',
  // baseURL: 'http://ditto.centralus.cloudapp.azure.com/aeromall/public/api',
  //baseURL: 'http://34.106.141.22/aeromall-admin/public/api'
  //baseURL: 'http://34.106.51.11/aeromall-admin/public/api'
  //baseURL: 'http://localhost:8000/api'
})
